import { useState } from 'react'

export const useToggle = () => {
  const [isOpen, setIsOpen] = useState(false)

  const toggle = (val?: boolean) => setIsOpen(val ?? !isOpen)

  return { isOpen, toggle }
}
